import * as celebrity from "./celebrity";
import * as useCelebrity from "./useCelebrity";

export const kol = {
  celebrity,
  useCelebrity,
};
